import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLockBodyScroll } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { BasketButtonError } from '@as-react/common-types';
import { CaretRightIcon } from '@yonderland/andes-icons';
import { BottomSheet, Box, Icon, LinkButton, Sidebar, Stack, TextAlpha, useIsClient, useMediaQueryMatchesOnMobile, } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SizeGuideAPI from '../../api/SizeGuideAPI';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { HtmlInclude } from '../common/html-include/HtmlInclude';
export const PromoBasketPopupSizeGuide = ({ sizeGuideInformation, basketValidationState, setBasketValidationState, onOpenChange, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint, sizeGuidePath, isSingleLanguageSite } = aemConfiguration;
    const [sizeGuideContent, setSizeGuideContent] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const isMobile = useMediaQueryMatchesOnMobile();
    const isClient = useIsClient();
    const title = t('product.size.guide.link');
    useLockBodyScroll(isOpen);
    const handleClose = () => {
        setIsOpen(false);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
    };
    const handleSizeGuideOpen = (e) => {
        e.preventDefault();
        if (basketValidationState === BasketButtonError.SKU) {
            setBasketValidationState(undefined);
        }
        setIsOpen(true);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(true);
    };
    const getContent = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!sizeGuideInformation)
            return null;
        const sizeGuideRequestParams = {
            brandId: sizeGuideInformation.brandId,
            genderId: sizeGuideInformation.genderFeatureId,
            isSingleLanguageSite: isSingleLanguageSite,
            productTypeId: sizeGuideInformation.productTypeFeatureId,
            sizeGuidePath: sizeGuidePath,
        };
        const data = yield SizeGuideAPI.fetchSizeGuide(servicesEndpoint, defaultRequestParams, sizeGuideRequestParams);
        if (!data || !data.url)
            return null;
        return SizeGuideAPI.fetchSizeGuideHTML(data.url);
    });
    useEffect(() => {
        getContent()
            .then(content => setSizeGuideContent(content))
            .catch(() => setSizeGuideContent(null));
    }, [sizeGuideInformation]);
    if (!sizeGuideContent)
        return null;
    const overlayContent = (_jsxs(Stack, { direction: "col", gap: "6", children: [_jsx(TextAlpha, { as: "h2", variant: "headingS", children: title }), _jsx(Box, { overflow: "y-auto", children: _jsx(HtmlInclude, { htmlFragment: sizeGuideContent }) })] }));
    return (_jsxs(Box, { paddingBlockEnd: { base: '2', md: '6' }, children: [_jsxs(LinkButton, { onClick: handleSizeGuideOpen, size: "sm", testId: "size_guide", children: [t('product.size.guide.link'), _jsx(Icon, { source: CaretRightIcon, size: "xs" })] }), isClient &&
                (isMobile ? (_jsx(BottomSheet, { ariaLabel: title, fullHeightOnScroll: true, hasCloseBtn: true, isOpen: isOpen, onClose: handleClose, testId: "promo-basket-size-guide-bottom-sheet", children: overlayContent })) : (_jsx(Sidebar, { ariaLabel: title, customWidth: "480px", hasBackdrop: true, hasCloseBtn: true, hasCloseBtnSpacing: false, isOpen: isOpen, onClose: handleClose, position: "fixed", side: "right", testId: "promo-basket-size-guide-sidebar", zIndex: "modal", children: overlayContent })))] }));
};
